import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  root: { position: 'relative', width: 320 },
  label: { fontSize: 12, color: 'rgba(0,0,0,0.6)', marginBottom: 6 },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid rgba(0,0,0,0.23)',
    borderRadius: 4,
    outline: 'none',
    fontSize: 14,
    boxSizing: 'border-box',
  },
  chipsWrap: { display: 'flex', flexWrap: 'wrap', marginTop: 8, maxHeight: 120, overflowY: 'auto' },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    border: '1px solid rgba(0,0,0,0.23)',
    borderRadius: 16,
    padding: '4px 10px',
    marginRight: 6,
    marginBottom: 6,
    background: '#fafafa',
    maxWidth: 280,
    flexShrink: 0,
  },
  chipText: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 13 },
  chipX: {
    marginLeft: 8,
    cursor: 'pointer',
    fontWeight: 700,
    lineHeight: 1,
    padding: '0 4px',
    fontSize: 14,
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9998,
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 9999,
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.23)',
    borderRadius: 4,
    marginTop: 4,
    maxHeight: 320,
    overflowY: 'auto',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  rowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px',
    borderBottom: '1px solid rgba(0,0,0,0.12)',
    fontSize: 12,
    color: 'rgba(0,0,0,0.7)'
  },
  clearAll: { cursor: 'pointer', color: '#1976d2' },
  option: {
    padding: '10px 12px',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
  },
  optionChecked: { background: 'rgba(25,118,210,0.08)' },
  checkmark: { width: 18, height: 18, marginRight: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #999', borderRadius: 3, fontSize: 12, flexShrink: 0 },
  checkmarkChecked: { background: '#1976d2', borderColor: '#1976d2', color: '#fff' },
  empty: { padding: '10px 12px', color: 'rgba(0,0,0,0.6)', fontSize: 13 }
};

function toStr(id) {
  return String(id);
}

export default class CustomMultiSelectDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, query: '' };
    this.inputRef = React.createRef();
  }

  getSelectedSet() {
    var set = {};
    var ids = this.props.selectedIds || [];
    for (var i = 0; i < ids.length; i++) {
      set[toStr(ids[i])] = true;
    }
    return set;
  }

  isSelected(optId) {
    var ids = this.props.selectedIds || [];
    var key = toStr(optId);
    for (var i = 0; i < ids.length; i++) {
      if (toStr(ids[i]) === key) return true;
    }
    return false;
  }

  getFilteredOptions() {
    var options = this.props.options || [];
    var q = (this.state.query || '').trim().toLowerCase();
    if (!q) return options;
    var result = [];
    for (var i = 0; i < options.length; i++) {
      var lbl = String(options[i].label || '').toLowerCase();
      if (lbl.indexOf(q) !== -1) result.push(options[i]);
    }
    return result;
  }

  handleToggle(opt) {
    var ids = this.props.selectedIds || [];
    var optKey = toStr(opt.id);
    var found = false;
    var next = [];
    for (var i = 0; i < ids.length; i++) {
      if (toStr(ids[i]) === optKey) {
        found = true;
      } else {
        next.push(ids[i]);
      }
    }
    if (!found) {
      next.push(opt.id);
    }
    this.props.onChange(next);
    this.setState({ query: '' });
  }

  handleRemove(optId) {
    var ids = this.props.selectedIds || [];
    var removeKey = toStr(optId);
    var next = [];
    for (var i = 0; i < ids.length; i++) {
      if (toStr(ids[i]) !== removeKey) next.push(ids[i]);
    }
    this.props.onChange(next);
  }

  handleClearAll() {
    this.props.onChange([]);
    this.setState({ query: '' });
  }

  openDropdown() {
    if (!this.props.disabled) {
      this.setState({ open: true });
    }
  }

  closeDropdown() {
    this.setState({ open: false, query: '' });
  }

  render() {
    var self = this;
    var label = this.props.label;
    var placeholder = this.props.placeholder;
    var disabled = this.props.disabled;
    var maxMenuItems = this.props.maxMenuItems || 200;
    var open = this.state.open;
    var query = this.state.query;
    var options = this.props.options || [];

    var selectedSet = this.getSelectedSet();
    var selectedCount = (this.props.selectedIds || []).length;

    var filtered = this.getFilteredOptions();
    var visibleOptions = filtered.slice(0, maxMenuItems);
    var hasMore = filtered.length > visibleOptions.length;

    var selectedChips = [];
    for (var i = 0; i < options.length; i++) {
      if (selectedSet[toStr(options[i].id)]) {
        selectedChips.push(options[i]);
      }
    }

    return (
      <div style={styles.root}>
        <div style={styles.label}>{label}</div>

        <input
          ref={this.inputRef}
          style={styles.input}
          value={query}
          placeholder={placeholder || 'Search...'}
          disabled={disabled}
          onFocus={function() { self.openDropdown(); }}
          onChange={function(e) { self.setState({ query: e.target.value, open: true }); }}
        />

        {selectedChips.length > 0 && (
          <div style={styles.chipsWrap}>
            {selectedChips.map(function(o) {
              return (
                <div key={toStr(o.id)} style={styles.chip} title={o.label}>
                  <div style={styles.chipText}>{o.label}</div>
                  <div
                    style={styles.chipX}
                    onClick={function(e) {
                      e.stopPropagation();
                      self.handleRemove(o.id);
                    }}
                  >
                    &times;
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {open && !disabled && (
          <React.Fragment>
            <div
              style={styles.backdrop}
              onClick={function() { self.closeDropdown(); }}
            />
            <div style={styles.dropdown}>
              <div style={styles.rowTop}>
                <div>Selected: {selectedCount}</div>
                {selectedCount > 0 && (
                  <div
                    style={styles.clearAll}
                    onClick={function() { self.handleClearAll(); }}
                  >
                    Clear all
                  </div>
                )}
              </div>

              {visibleOptions.length === 0 ? (
                <div style={styles.empty}>
                  {options.length ? 'No matches' : 'No options'}
                </div>
              ) : (
                visibleOptions.map(function(o) {
                  var checked = self.isSelected(o.id);
                  var optionStyle = Object.assign({}, styles.option, checked ? styles.optionChecked : {});
                  var checkStyle = Object.assign({}, styles.checkmark, checked ? styles.checkmarkChecked : {});

                  return (
                    <div
                      key={toStr(o.id)}
                      style={optionStyle}
                      onClick={function() { self.handleToggle(o); }}
                    >
                      <span style={checkStyle}>
                        {checked ? '\u2713' : ''}
                      </span>
                      <div>{o.label}</div>
                    </div>
                  );
                })
              )}

              {hasMore && (
                <div style={styles.empty}>
                  Showing first {visibleOptions.length} results. Refine search to see more.
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

CustomMultiSelectDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  onChange: PropTypes.func.isRequired,
  maxMenuItems: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/CustomMultiSelectDropdown.js